module.exports = __webpack_public_path__ + "static/media/list_pendaftaran.51490451.png";